<template>
  <div class="note-editor">
    <div class="note-editing-area">
      <!-- eslint-disable vue/no-v-html -->
      <div class="note-editable" v-html="htmlData"></div>
      <!--eslint-enable-->
    </div>
  </div>
</template>

<script>
export default { props: { htmlData: { type: String } } }
</script>

<style></style>
